const $ = require('jquery');
window.jQuery = $;
require("modal");
import React from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select';
import 'isomorphic-fetch';
import { getRegions, getRegion, getDealer } from './api/apiMethods.js';
import { Utilities } from './utilities.js';
import { Map } from './map.js';
import { MapContainer } from './map.js';
import { RegionSelector } from './regionselector.js';
import { DealerTable } from './dealertable.js';
import { ContactTable } from './contacttable.js';
import { Modal } from './contactcardmodal.js';
import { PlacesSearchBox } from './closestDealers/placesSearchBox.js';

class FindADealer extends React.Component {
    constructor() {
        super();
        // askedLocation = if asked for geolocation, set true if to disable GeoLocation
        this.state =
        {
            regions: [],
            regionsDropdown: [],
            activeRegion: {},
            loadingRegions: true,
            loadingDealers: true,
            showModal: true,
            activeRegionId: '',
            geoLocationSuccess: false,
            showLocationError: false,
            selectedDealer: {},
            askedLocation: false
        };

        this.userLocationAddress = "";

        this.handleRegionChange = this.handleRegionChange.bind(this);
        this.handleDealerClick = this.handleDealerClick.bind(this);
        this.handleRegionClick = this.handleRegionClick.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleGeoLocation = this.handleGeoLocation.bind(this);

        //Translations
        this.translations = JSON.parse($("#translations").html());

        //PageData
        if ($("#pageData").length) {
            this.pageData = JSON.parse($("#pageData").html());
        } else {
            this.pageData = null;
        }

        //Load regions
        this.getRegionsData();
    }

    render() {
        const isPersonRegion = this.state.activeRegion.IsPersonRegion;
        const isDealerRegion = this.state.activeRegion.IsDealerRegion;
        let contactTable = null;
        let dealerTable = null;
        let introText = null;
        let locationError = null;

        if (isPersonRegion) {

            contactTable = <ContactTable activeRegion={this.state.activeRegion}
                loadingDealers={this.state.loadingDealers}
                onDealerClick={this.handleDealerClick}
                translations={this.translations.table} />
        }
        if (isDealerRegion) {

            dealerTable = <DealerTable activeRegion={this.state.activeRegion}
                loadingDealers={this.state.loadingDealers}
                onDealerClick={this.handleDealerClick}
                translations={this.translations.table} />

            if (this.pageData != null) {
                introText = <div className="main-body" dangerouslySetInnerHTML={{ __html: Utilities.htmlDecode(this.pageData.findadealer.body) }} ></div>
            }

        }

        if (this.state.showLocationError) {
            locationError = <div id="location-error" className="error">{this.translations.closestDealers.locationUnknown}</div>
        }

        return (<div>
            <div className="container">
                <div className='hidden-print'>
                    <Modal ref="modal" contactCard={this.state.selectedDealer} translations={this.translations.modal} isPerson={isPersonRegion} />
                    <div>
                        {locationError}
                    </div>
                </div>
            </div>
            <div className='hidden-print'>
                {isDealerRegion && isPersonRegion &&
                    <p className="indicator">
                        <span className="icon-marker red-marker"></span>
                        {this.translations.table.headerDealer}
                        <span className="icon-marker yellow-marker"></span>
                        {this.translations.table.headerContact}
                    </p>
                }
                {!isDealerRegion || !isPersonRegion &&
                    <div className="space"></div>
                }
                {!isDealerRegion && !isPersonRegion &&
                    <div className="space"></div>
                }
                <div className="map-container">
                    <Map activeRegion={this.state.activeRegion}
                        onDealerClick={this.handleDealerClick}
                        onRegionClick={this.handleRegionClick}
                        regions={this.state.regions}
                        geoLocationSuccess={this.state.geoLocationSuccess}
                        userLocation={this.state.userLocation}
                        userLocationAddress={this.userLocationAddress}
                        handleSearch={this.handleSearch}
                        loadingDealers={this.state.loadingDealers} />
                    <Select name="region-dropdown"
                        value={this.state.activeRegionId}
                        options={this.state.regionsDropdown}
                        onChange={this.handleRegionChange}
                        isLoading={this.state.loadingRegions}
                        clearable={false}
                        classNamePrefix='Select'
                        className='Select'
                        placeholder={this.state.activeRegion.Name} />
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                        {introText}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        {isDealerRegion &&
                            <div>{dealerTable}</div>
                        }
                        {isPersonRegion &&
                            <div>{contactTable}</div>
                        }
                    </div>
                </div>
            </div>
        </div>);
    }

    openModal() {
        $(ReactDOM.findDOMNode(this.refs.modal)).modal();
    }

    handleDealerClick(dealer, event) {
        if (event.target === undefined || !event.target.className.includes("no-modal")) {
            this.getDealerData(dealer.Id);
        }
    }

    handleRegionClick(regionId) {
        this.setState({
            activeRegionId: regionId,
            showLocationError: false
        });
        this.getRegionData(regionId);
    }

    handleRegionChange(val) {
        this.setState({
            activeRegionId: val.value,
            showLocationError: false
        });
        this.getRegionData(val.value);
    }

    handleSearch() {
        this.setState({
            askedLocation: true,
            geoLocationSuccess: false,
            showLocationError: false
        });
        this.userLocationAddress = null;
    }

    handleGeoLocation(countryIsoCode, userLocation) {
        if (this.state.activeRegion.RegionIsoCode === countryIsoCode) {
            this.setState({
                geoLocationSuccess: true,
                userLocation: userLocation,
                askedLocation: true,
            });
        } else {
            for (let i = 0; i < this.state.regions.length; i++) {
                let regionIsoCode = this.state.regions[i].RegionIsoCode;
                if (regionIsoCode === countryIsoCode) {
                    this.setState({
                        activeRegionId: this.state.regions[i].Id,
                        geoLocationSuccess: true,
                        userLocation: userLocation,
                        askedLocation: true
                    });
                    this.getRegionData(this.state.regions[i].Id);
                    break;
                }
            }
        }
    }

    handleLocationSuccess(position) {
        var userLocation = new google.maps.LatLng({ lat: position.coords.latitude, lng: position.coords.longitude });
        var geocoder = new google.maps.Geocoder;

        geocoder.geocode({ "location": userLocation }, (results, status) => {
            if (status === "OK") {
                
                for (let i = 0; i < results.length; i++) {
                    for (let j = 0; j < results[i].types.length; j++) {
                        if (results[i].types[j] === "street_address") {
                            this.userLocationAddress = results[i].formatted_address;
                        }
                        if (results[i].types[j] === "country") {
                            
                            let countryIsoCode = results[i].address_components[0].short_name;
                            this.handleGeoLocation(countryIsoCode, userLocation);
                            break;
                        }
                    }
                }
            }
        });
    }

    showError(error) {
        this.setState({
            showLocationError: true
        });
    }

    getGeoLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.handleLocationSuccess.bind(this), this.showError.bind(this));
           
        } else {
            console.log("Geolocation not supported");
        }
    }

    loadingDealerTableComplete() {
        this.setState({ loadingDealers: false });
    }

    //Api calls
    getRegionsData() {
        getRegions()
            .then(data => {
                // No results
                if (data.length === 0) {
                    this.setState({ activeRegion: {}, regions: [], loadingRegions: false, loadingDealers: false })
                    return;
                }

                //Get active region
                let activeRegion = data.find(dealer => dealer.Active === true);

                //Create array for dropdown
                let regionsDropDown = data.map((region) => {
                    return { value: region.Id, label: region.Name }
                });

                if (activeRegion === undefined) {
                    activeRegion = data[0];
                }

                this.setState({
                    activeRegion: activeRegion,
                    regionsDropdown: regionsDropDown,
                    regions: data,
                    loadingDealers: true,
                    loadingRegions: false,
                    activeRegionId: activeRegion.Id,
                });

                if (!activeRegion.IsInternational) {
                    this.getRegionData(activeRegion.Id);
                }
                if (activeRegion.IsInternational && !this.state.askedLocation) {
                    this.getGeoLocation();
                }
                return data;
            });
    }

    getRegionData(regionId) {
        getRegion(regionId)
            .then(data => {
                this.setState({ activeRegion: data, loadingDealers: false });
                if (!data.IsPersonRegion && !this.state.askedLocation ) {
                    this.getGeoLocation();
                }
            });
    }

    getDealerData(dealerId) {
        getDealer(dealerId)
            .then(data => {
                this.setState({ selectedDealer: data });
                this.openModal();
            });
    }
}

ReactDOM.render(
    <FindADealer />,
    document.getElementById('findADealer')
);